import React from 'react';

import {Separator} from 'src/components/separator';

import Button from '@pb/kit-component-button';
import {Group, Item} from '@pb/kit-component-group';

export const AiReviewTour = () => {
    return (
        <Group direction="v" className="pt-s">
            <Group direction="v">
                <Item><strong>AI Review</strong></Item>
                <Separator/>
                <Group gap="s" alignItems="center">
                    <Item><strong>Click</strong></Item>
                    <Button variant="Type.PRIMARY">AI Review</Button>
                    <Item><strong>to review event with AI.</strong></Item>
                </Group>
            </Group>
        </Group>
    );
};
